export default {
  status: '',
  id: '',
  type_support: '',
  conclusion: '',
}
